function initClientSideMetrics(performanceTracker) {
    //Setup the initial values
    const zeroValues = ["currHour", "finishedProjects", "finishedOnTime", "finishedTooLate", "finishedProjectsVeryLate","finishedProjectsLittleLate","finishedProjectsVeryOnTime","finishedProjectsLittleOnTime", "dueDatePerformance", "flow", "currProjectTooLate", "projectRevenue", "laborCost", "laborHours", "totalTrainCosts", "penaltyCost", "totalCost", "profit"];

    zeroValues.forEach(currVal => {
        performanceTracker.setInitialMetric(currVal, 0);
    })

    performanceTracker.setInitialMetric("currProjectOnTime", getInitialProjectAmount(performanceTracker.simulator));
    performanceTracker.setInitialMetric("currWorking", getInitialCurrWorking(performanceTracker.simulator));
    performanceTracker.setInitialMetric("currCapacities", performanceTracker.simulator.resourcePool.getCurrentCapacities());
    performanceTracker.setInitialMetric("load", { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 });
    performanceTracker.setInitialMetric("waitingTime", { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 });
    performanceTracker.setInitialMetric("readytostart", { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 });
    performanceTracker.setInitialMetric("hoursSpent", { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 });
    performanceTracker.setInitialMetric("hoursOutput", { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 });
    performanceTracker.setInitialMetric("currTrained", { "B": null, "O": null, "P": null, "M": null, "I": null, "A": null });
    performanceTracker.setInitialMetric("currProjects", getCurrentProjects(performanceTracker.simulator));
    performanceTracker.setInitialMetric("deliveryDistribution", {delayVery: 0, delayLittle: 0, onTimeVery: 0, onTimeLittle: 0});
    performanceTracker.setInitialMetric("activeProjects", getInitialActiveProjects(performanceTracker.simulator));

    var waitingTimesPerGroup = {}
    var cumulativeWaitingTimesPerGroup = {}
    var waitingTimesPerGroupHours = {}
    var cumulativeWaitingTimesPerGroupHours = {}
    var resourceIDs = ["B", "O", "P", "M", "I", "A", "G", "X"]
    resourceIDs.forEach(currID => {
        waitingTimesPerGroup[currID] = {};
        cumulativeWaitingTimesPerGroup[currID] = {};
        waitingTimesPerGroupHours[currID] = {};
        cumulativeWaitingTimesPerGroupHours[currID] = {};
        resourceIDs.forEach(currID2 => {
            waitingTimesPerGroup[currID][currID2] = 0;
            cumulativeWaitingTimesPerGroup[currID][currID2] = 0;
            waitingTimesPerGroupHours[currID][currID2] = 0;
            cumulativeWaitingTimesPerGroupHours[currID][currID2] = 0;
        })
    })


    //Get all the projects that just started
    performanceTracker.simulator.projectPool.projects.forEach(currProject => {
        if (currProject.startHour == performanceTracker.simulator.hoursPassed) {
            currProject.getReadyToStartTasks().forEach(currTask => {

                waitingTimesPerGroup["X"][currTask.resourceGroupID] += 1;
                waitingTimesPerGroupHours["X"][currTask.resourceGroupID] += currTask.getRemainingWorkHours();
                cumulativeWaitingTimesPerGroup["X"][currTask.resourceGroupID] += 1;
                cumulativeWaitingTimesPerGroupHours["X"][currTask.resourceGroupID] += currTask.getRemainingWorkHours();
            })
        }
    })


    performanceTracker.setInitialMetric("waitingTimesPerGroup", waitingTimesPerGroup);
    performanceTracker.setInitialMetric("cumulativeWaitingTimesPerGroup", cumulativeWaitingTimesPerGroup);
    performanceTracker.setInitialMetric("waitingTimesPerGroupHours", waitingTimesPerGroupHours);
    performanceTracker.setInitialMetric("cumulativeWaitingTimesPerGroupHours", cumulativeWaitingTimesPerGroupHours);

    //Setup the calculations
    const updateFunctions = [updateActiveProjects, updateTrained, updateReadyToStartLoads, updateProjectMetrics, updateLabourMetrics, updateFinishedWorkMetrics, updateTrainCosts, updatePenaltyCosts, updateFlowMetrics, updateDueDateMetrics, updateTotalCost, updateLoads, updateCurrCapacities, updateWaitingTimes, updateWaitingTimesPerGroup, updateCurrentProjects];
    updateFunctions.forEach(currFunc => {
        performanceTracker.registerMetric(currFunc);
    })


    const forceUpdateFunctions = [updateActiveProjects];
    forceUpdateFunctions.forEach(currFunc => {
        performanceTracker.registerForceUpdateMetric(currFunc);
    })
}

function getInitialActiveProjects(simulator) {
    var activeProjects = 0;
    simulator.projectPool.projects.forEach(currProject => {
        if (currProject.isActive()) {
            activeProjects += 1;
        }
    })

    return activeProjects;
}

function updateActiveProjects(simulator, currMetric) {
    currMetric.activeProjects = getInitialActiveProjects(simulator);
}


function getInitialProjectAmount(simulator) {
    let projectAmount = 0;
    simulator.projectPool.projects.forEach(currProject => {
        if (!currProject.isFinished()) {
            projectAmount += 1;
        }
    });
    return projectAmount;
}

function updateCurrentProjects(simulator, currMetric) {
    currMetric.currProjects = getCurrentProjects(simulator);
}

function getCurrentProjects(simulator) {
    let currProjects = {"red": 0, "blue": 0, "green": 0, "yellow": 0};

    simulator.projectPool.projects.forEach(currProject => {
        if (!currProject.isFinished()) {
            currProjects[currProject.getProjectStatus()] += 1;
        }
    });

    return currProjects;
}

function updateTrained(simulator, currMetric) {
    var currTrained = {};
    simulator.resourcePool.resourceGroups.forEach(currGroup => {
        if (currGroup.alternateName != null) {
            currTrained[currGroup.id] = currGroup.alternateName;
        }
    });


    currMetric.currTrained = currTrained;
}

function updateCurrCapacities(simulator, currMetric) {
    currMetric.currCapacities = simulator.resourcePool.getCurrentCapacities();
}

function updateProjectMetrics(simulator, currMetric) {
    //Setup the default values to calculate
    currMetric.finishedOnTime = 0;
    currMetric.finishedTooLate = 0;
    currMetric.projectRevenue = 0;
    currMetric.currProjectTooLate = 0;
    currMetric.currProjectOnTime = 0;
    currMetric.finishedProjectsVeryLate = 0;
    currMetric.finishedProjectsLittleLate = 0;
    currMetric.finishedProjectsVeryOnTime = 0;
    currMetric.finishedProjectsLittleOnTime = 0;
    currMetric.deliveryDistribution = {delayVery: 0, delayLittle: 0, onTimeVery: 0, onTimeLittle: 0};

    var veryLittleTreshold = 10;
    

    simulator.projectPool.projects.forEach(currProject => {
        if (currProject.isFinished()) {
            currMetric.projectRevenue += currProject.revenue;

            var remainingBuffer = ((currProject.startHour + currProject.leadTimeHours) - currProject.getMinimumEndHour()) / 8;
            
            if (remainingBuffer < -veryLittleTreshold) {
                currMetric.finishedProjectsVeryLate += 1;
                currMetric.deliveryDistribution.delayVery += Math.abs(remainingBuffer);
            }
            else if (remainingBuffer < 0) {
                currMetric.finishedProjectsLittleLate += 1;
                currMetric.deliveryDistribution.delayLittle += Math.abs(remainingBuffer);
            }
            else if (remainingBuffer > veryLittleTreshold) {
                currMetric.finishedProjectsVeryOnTime += 1;
                currMetric.deliveryDistribution.onTimeVery += Math.abs(remainingBuffer);
            }
            else {
                currMetric.finishedProjectsLittleOnTime += 1;
                currMetric.deliveryDistribution.onTimeLittle += Math.abs(remainingBuffer);
            }
        }

        if (!currProject.isFinished()) {
            if (currProject.isDelayed()) {
                currMetric.currProjectTooLate += 1
            }
            else {
                currMetric.currProjectOnTime += 1
            }
        }
    })

    currMetric.finishedOnTime = currMetric.finishedProjectsVeryOnTime + currMetric.finishedProjectsLittleOnTime;
    currMetric.finishedTooLate = currMetric.finishedProjectsVeryLate + currMetric.finishedProjectsLittleLate;
    currMetric.finishedProjects = currMetric.finishedOnTime + currMetric.finishedTooLate;
}


function updateLabourMetrics(simulator, currMetric) {

    currMetric.laborHours = simulator.performanceTracker.getLatestMetrics().laborHours,
        currMetric.currWorking = { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 }
    currMetric.hoursSpent = { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 }
    currMetric.hoursOutput = { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 }


    simulator.resourcePool.resourceGroups.forEach(currGroup => {
        currGroup.resources.forEach(currResource => {
            if (currResource.isActive) {
                currMetric.laborHours += 1
                currMetric.currWorking[currGroup.id] += 1;
            }

            currMetric.hoursSpent[currResource.lastResourceWorked] += currResource.workPastHour;
            currMetric.hoursOutput[currResource.lastResourceWorked] += currResource.outputPastHour;
        })
    })

    currMetric.laborCost = currMetric.laborHours * simulator.params.costPerLabourHour;
}


function updateFinishedWorkMetrics(simulator, currMetric) {
    currMetric.finishedWorkAmount = 0;

    simulator.projectPool.projects.forEach(currProject => {
        currProject.taskArray.forEach(currTask => {
            if (currTask.resourceGroupID != "G") {
                currMetric.finishedWorkAmount += currTask.currWorkedHours;
            }
        })
    });
}

function updateTrainCosts(simulator, currMetric) {
    currMetric.totalTrainCosts = 0;
    simulator.resourcePool.resourceGroups.forEach(currGroup => {
        currMetric.totalTrainCosts += currGroup.trainingCost;
    });
}


function updatePenaltyCosts(simulator, currMetric) {
    currMetric.penaltyCost = simulator.performanceTracker.getLatestMetrics().penaltyCost;

    simulator.projectPool.projects.forEach(currProject => {
        if (currProject.isFinished() || !currProject.isDelayed()) {
            return;
        }

        currMetric.penaltyCost += simulator.params.penaltyPerHour;
    })
}

function updateFlowMetrics(simulator, currMetric) {
    currMetric.flow = 0;
    if (currMetric.laborHours > 0) {
        currMetric.flow = currMetric.finishedWorkAmount / currMetric.laborHours;
    }
}

function updateDueDateMetrics(simulator, currMetric) {
    currMetric.dueDatePerformance = 0;
    if (currMetric.finishedProjects > 0) {
        currMetric.dueDatePerformance = 100 * currMetric.finishedOnTime / currMetric.finishedProjects;
    }
}

function updateTotalCost(simulator, currMetric) {
    currMetric.totalCost = currMetric.laborCost + currMetric.penaltyCost + currMetric.totalTrainCosts;
    currMetric.profit = currMetric.projectRevenue - currMetric.totalCost;
}

function updateLoads(simulator, currMetric) {
    currMetric.load = {};
    simulator.resourcePool.resourceGroups.forEach(currResourceGroup => {
        currMetric.load[currResourceGroup.id] = 0;
    });
    simulator.projectPool.projects.forEach(currProject => {
        currProject.taskArray.forEach(currTask => {

            var load = calculateLoad(currTask, simulator)
            currMetric.load[currTask.resourceGroupID] += load * simulator.params.averageLoadMultiplier;
        })
    });
}

function updateWaitingTimes(simulator, currMetric) {
    currMetric.waitingTime = {};
    simulator.resourcePool.resourceGroups.forEach(currResourceGroup => {
        currMetric.waitingTime[currResourceGroup.id] = 0;
    });

    simulator.projectPool.getAllReadyTasks().forEach(currTask => {

        //Gray resources don't have waiting times
        if (currTask.resourceGroupID == "G") {
            return;
        }

        //Dont add first iteration of readyToStartHour
        if (currTask.isReadyToStartHour == -1) {
            return;
        }

        currMetric.waitingTime[currTask.resourceGroupID] += currTask.getRemainingWorkHours();
    })
}


function updateWaitingTimesPerGroup(simulator, currMetric) {
    var waitingTimesPerGroup = {}
    var cumulativeWaitingTimesPerGroup = {}
    var waitingTimesPerGroupHours = {}
    var cumulativeWaitingTimesPerGroupHours = {}

    var resourceIDs = ["B", "O", "P", "M", "I", "A", "G", "X"]
    resourceIDs.forEach(currID => {
        waitingTimesPerGroup[currID] = {};
        cumulativeWaitingTimesPerGroup[currID] = {};
        waitingTimesPerGroupHours[currID] = {};
        cumulativeWaitingTimesPerGroupHours[currID] = {};
        resourceIDs.forEach(currID2 => {
            waitingTimesPerGroup[currID][currID2] = 0;
            cumulativeWaitingTimesPerGroup[currID][currID2] = 0;
            waitingTimesPerGroupHours[currID][currID2] = 0;
            cumulativeWaitingTimesPerGroupHours[currID][currID2] = 0;
        })
    })

    //Get all the projects that just started
    simulator.projectPool.projects.forEach(currProject => {
        if (currProject.startHour == simulator.hoursPassed) {
            currProject.getReadyToStartTasks().forEach(currTask => {
                if (currTask.currentResource != null) {
                    return;
                }

                waitingTimesPerGroup["X"][currTask.resourceGroupID] += 1;
                waitingTimesPerGroupHours["X"][currTask.resourceGroupID] += currTask.getRemainingWorkHours();
            })
        }
    })

    //Get all the tasks that are going to be finished this hour
    simulator.projectPool.projects.forEach(currProject => {
        if (currProject.getMinimumEndHour() < simulator.hoursPassed - 1) {
            return;
        }

        currProject.taskArray.forEach(currTask => {

            // if(currTask.resourceGroupID == "P"){
            //     console.log(currTask.startHour + currTask.totalWorkHours, simulator.hoursPassed)
            // }

            var difference = simulator.hoursPassed - (currTask.startHour + currTask.totalWorkHours);

            if (difference > 0 && difference <= 1) {
                currTask.childTasks.forEach(currChildTask => {
                    waitingTimesPerGroup[currTask.resourceGroupID][currChildTask.resourceGroupID] += 1;
                    waitingTimesPerGroupHours[currTask.resourceGroupID][currChildTask.resourceGroupID] += currChildTask.getRemainingWorkHours();
                })

                if (currTask.childTasks.length == 0) {
                    waitingTimesPerGroup[currTask.resourceGroupID]["X"] += 1;
                    waitingTimesPerGroupHours[currTask.resourceGroupID]["X"] += 1;
                }
            }
        })
    })

    var lastCumulativeWaitingTimesPerGroup = simulator.performanceTracker.getLatestMetrics().cumulativeWaitingTimesPerGroup;
    var lastCumulativeWaitingTimesPerGroupHours = simulator.performanceTracker.getLatestMetrics().cumulativeWaitingTimesPerGroupHours;
    resourceIDs.forEach(currID => {
        resourceIDs.forEach(currID2 => {
            cumulativeWaitingTimesPerGroup[currID][currID2] = lastCumulativeWaitingTimesPerGroup[currID][currID2] + waitingTimesPerGroup[currID][currID2];
            cumulativeWaitingTimesPerGroupHours[currID][currID2] = lastCumulativeWaitingTimesPerGroupHours[currID][currID2] + waitingTimesPerGroupHours[currID][currID2];
        })
    })

    currMetric.waitingTimesPerGroup = waitingTimesPerGroup;
    currMetric.cumulativeWaitingTimesPerGroup = cumulativeWaitingTimesPerGroup;
    currMetric.waitingTimesPerGroupHours = waitingTimesPerGroupHours;
    currMetric.cumulativeWaitingTimesPerGroupHours = cumulativeWaitingTimesPerGroupHours;
}

function calculateLoad(currTask, simulator) {
    if (currTask.isFinished() || (currTask.project.startHour > simulator.params.simulationMaxDurationHours && simulator.hoursPassed != simulator.params.simulationMaxDurationHours)) {
        return 0;
    }

    // If the project has not started yet, the load is 0
    if (currTask.project.startHour > simulator.hoursPassed) {
        return 0;
    }

    var currTaskDuedate = currTask.originalStartHour + currTask.project.leadTimeHours;
    var remainingTillDuedate = currTaskDuedate - simulator.hoursPassed
    var remainingWorkhours = currTask.totalWorkHours - currTask.currWorkedHours;
    var load = 1;
    if (remainingTillDuedate > 0) {
        load = Math.min(remainingWorkhours / remainingTillDuedate, 1);
    }

    return load;
}

function updateReadyToStartLoads(simulator, currMetric) {
    currMetric.readytostart = { "B": 0, "O": 0, "P": 0, "M": 0, "I": 0, "A": 0 };

    var readyToStartTasks = simulator.projectPool.getAllReadyTasks();
    readyToStartTasks.forEach(currTask => {
        var load = calculateLoad(currTask, simulator)
        currMetric.readytostart[currTask.resourceGroupID] += load * simulator.params.averageLoadMultiplier;
    })
}

//For keeping track of how many resources per group are working, we initialize it to prevent the 0 values in the beginning
function getInitialCurrWorking(simulator) {
    var currWorking = {};
    simulator.resourcePool.resourceGroups.forEach(currGroup => {
        currWorking[currGroup.id] = 0;
        currGroup.resources.forEach(currResource => {
            if (currResource.isActive) {
                currWorking[currGroup.id] += 1;
            }
        })
    });

    return currWorking;
}

module.exports = { initClientSideMetrics, updateLoads }